import Icon from '../icon';
import {getRestProps} from '../utils';

export default function(obj, _Vdt, blocks, $callee) {
    _Vdt || (_Vdt = Vdt);
    obj || (obj = {});
    blocks || (blocks = {});
    var h = _Vdt.miss.h, hc = _Vdt.miss.hc, hu = _Vdt.miss.hu, widgets = this && this.widgets || {}, _blocks = {}, __blocks = {},
        __u = _Vdt.utils, extend = __u.extend, _e = __u.error, _className = __u.className, __slice = __u.slice, __noop = __u.noop,
        __m = __u.map, __o = __u.Options, _getModel = __o.getModel, _setModel = __o.setModel,
        _setCheckboxModel = __u.setCheckboxModel, _detectCheckboxChecked = __u.detectCheckboxChecked,
        _setSelectModel = __u.setSelectModel,
        self = this.data, $this = this, scope = obj, Animate = self && self.Animate, parent = ($callee || {})._super;

    const {
    _value, count, className, 
    disabled, half
} = self.get();

const classNameObj = {
    'k-rate': true,
    'k-disabled': disabled,
    [className]: className,
};

const icon = (_blocks['icon'] = function(parent) {
        return h(Icon, {
            'className': 'ion-android-star',
            '_context': $this
        });
    }) && (__blocks['icon'] = function(parent) {
        var args = arguments;
        return blocks['icon'] ? blocks['icon'].apply($this, [function() {
            return _blocks['icon'].apply($this, args);
        }].concat(__slice.call(args, 1))) : _blocks['icon'].apply($this, args);
    }) && __blocks['icon'].apply($this, [__noop])

    return h('div', {
        ...function() {try {return (getRestProps(self) )} catch(e) {_e(e)}}.call($this),
        'ev-mouseleave': function() {try {return (self.onMouseLeaveComponent )} catch(e) {_e(e)}}.call($this)
    }, function() {try {return ((() => {
        const ret = [];
        for (let i = 0; i < count; i++) {
            const className = _value >= i + 1 ? 
                'k-full' : _value === i + 0.5 ? 
                    'k-half' : null;
            const halfStep = half ? i + 0.5 : i + 1;
            ret.push(
                h('div', null, [
        h('div', {
            'ev-click': function() {try {return (self.onClick.bind(self, halfStep) )} catch(e) {_e(e)}}.call($this),
            'ev-mouseenter': function() {try {return (self.onMouseEnter.bind(self, halfStep) )} catch(e) {_e(e)}}.call($this)
        }, function() {try {return (icon )} catch(e) {_e(e)}}.call($this), 'k-first'),
        h('div', {
            'ev-click': function() {try {return (self.onClick.bind(self, i + 1) )} catch(e) {_e(e)}}.call($this),
            'ev-mouseenter': function() {try {return (self.onMouseEnter.bind(self, i + 1) )} catch(e) {_e(e)}}.call($this)
        }, function() {try {return (icon )} catch(e) {_e(e)}}.call($this), 'k-second')
    ], _className(function() {try {return ({"k-item": true, [className]: className } )} catch(e) {_e(e)}}.call($this)))
            );
        }
        return ret;
    })() )} catch(e) {_e(e)}}.call($this), _className(function() {try {return (classNameObj )} catch(e) {_e(e)}}.call($this)))
}